"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Disclaimer = void 0;
var _reactQuery = require("@tanstack/react-query");
var _react = require("react");
var _client = _interopRequireDefault(require("react-dom/client"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _styledComponentThemes = require("../../_nextgen/packages/styled-component-themes");
var _HtmlText = _interopRequireDefault(require("../../packages/HtmlText"));
var _IconLibrary = require("../../packages/IconLibrary");
var _tooltip = _interopRequireDefault(require("../../packages/tooltip"));
var _index = _interopRequireDefault(require("./index.styled"));
var colors = _interopRequireWildcard(require("./index.themes"));
var Themes = _interopRequireWildcard(require("./themes"));
var _redux = require("../../packages/redux");
var _analytics = _interopRequireWildcard(require("../analytics"));
var _index3 = _interopRequireWildcard(require("./index.ducks"));
var _jsxRuntime = require("react/jsx-runtime");
const DisclaimerTrigger = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  let {
    children,
    handleClick,
    code,
    text,
    triggerRef,
    ...rest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.Disclaimer, {
    ...rest,
    "data-testid": "DisclaimerTrigger",
    children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Trigger, {
      type: "button",
      onClick: handleClick,
      "data-code": code,
      "data-text": text,
      "aria-label": `Open Disclaimer - ${code}`,
      "aria-describedby": code,
      ref: (0, _reactMergeRefs.default)([triggerRef, ref].filter(Boolean))
    })]
  });
});
const DisclaimerTheme = function (_ref2) {
  let {
    theme
  } = _ref2;
  const formattedTheme = theme === null || theme === void 0 ? void 0 : theme.toLowerCase();
  const Theme = Themes[formattedTheme] || Themes.lexus;
  (0, _react.useEffect)(function () {
    if (!document.querySelector("#tippy-disclaimer-theme-injection")) {
      const container = document.createElement("DIV");
      container.id = "tippy-disclaimer-theme-injection";
      document.body.appendChild(container);
      const root = _client.default.createRoot(container);
      root.render(/*#__PURE__*/(0, _jsxRuntime.jsx)(Theme, {}));
    }
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};
const Disclaimer = function (props) {
  var _theme$theme;
  const {
    code,
    text: textContent,
    children = "*",
    placement = "right",
    defaultBody,
    defaultCode,
    ...rest
  } = props;
  const [select, dispatch] = (0, _redux.useReducerManager)({
    id: "DISCLAIMERS",
    reducer: _index3.default,
    initialState: _index3.initialState,
    persist: true
  });
  const QueryClient = (0, _reactQuery.useQueryClient)();
  const {
    client,
    enableDisclaimers
  } = QueryClient.getDefaultOptions();
  const theme = (0, _styledComponentThemes.useTheme)();
  const formattedTheme = typeof theme === "string" ? theme.toLowerCase() : theme === null || theme === void 0 ? void 0 : (_theme$theme = theme.theme) === null || _theme$theme === void 0 ? void 0 : _theme$theme.toLowerCase();
  const [content, setContent] = (0, _react.useState)("...");
  const [isVisible, setIsVisible] = (0, _react.useState)(false);
  const contentStringTemplate = function (e) {
    return `<p>${formattedTheme === "toyota" ? "* " : ""} ${e}</p>`;
  };
  const codes = (0, _index3.getDisclaimerArray)(code);
  const textCodes = codes.filter(function (i) {
    return typeof i === "string";
  });
  const resolvedDisclaimers = select((0, _index3.getDisclaimer)(textCodes));
  const themeOverride = (0, _styledComponentThemes.useTheme)();
  (0, _react.useEffect)(function () {
    if (!isVisible) return;
    (async function () {
      const reinjected = typeof resolvedDisclaimers === "undefined" ? undefined : codes.map(function (i) {
        if (typeof i === "function") {
          return i();
        }
        const lookup = resolvedDisclaimers.find(function (k) {
          return k.code === i;
        });
        return lookup ? lookup.body : i;
      });
      const promises = reinjected === null || reinjected === void 0 ? void 0 : reinjected.map(function (i) {
        if (i instanceof Promise) {
          return i;
        }
        return new Promise(function (resolve) {
          return resolve(i);
        });
      });
      Promise.all(promises !== null && promises !== void 0 ? promises : []).then(function () {
        let resolvedPromises = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        setContent(resolvedPromises === null || resolvedPromises === void 0 ? void 0 : resolvedPromises.map(contentStringTemplate).join(""));
      });
    })();
  }, [isVisible, resolvedDisclaimers]);
  let text = formattedTheme === "toyota" && textContent ? `* ${textContent}` : textContent;
  if (Array.isArray(text)) {
    text = text.map(function (i) {
      return `<p>${i}</p>`;
    }).join("");
  }
  const instance = (0, _react.useRef)();
  const triggerRef = (0, _react.useRef)();
  const onCreate = function (tippy) {
    instance.current = tippy;
  };
  const handleOnCloseClick = function (e) {
    e.stopPropagation();
    if (instance.current) {
      instance.current.hide();
    }
    if (triggerRef.current !== document.activeElement) {
      var _triggerRef$current;
      triggerRef === null || triggerRef === void 0 ? void 0 : (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.focus();
    }
  };
  const handleOnShow = function () {
    const disclaimerContentNotEmpty = content && content !== _index3.DEFAULT_DISCLAIMER.body && content !== "...";
    if (text || disclaimerContentNotEmpty) {
      return;
    }
    dispatch((0, _index3.requestDisclaimer)(code, rest, client, enableDisclaimers, defaultBody, defaultCode));
  };
  const handleOnShown = function () {
    fireAnalytics("open", {
      code,
      text: content || text
    });
    setIsVisible(true);
  };
  const handleOnMount = function () {
    const poppers = document.getElementsByClassName("tippy-popper");
    const lastPopper = poppers === null || poppers === void 0 ? void 0 : poppers[poppers.length - 1];
    if (lastPopper) {
      lastPopper.classList.add(`${formattedTheme === "toyota" ? "toyota" : "lexus"}-theme`);
    }
    const tooltips = document.getElementsByClassName("tippy-tooltip");
    const lastTooltip = tooltips === null || tooltips === void 0 ? void 0 : tooltips[tooltips.length - 1];
    if (lastTooltip) {
      lastTooltip.classList.add(`background-${themeOverride}`);
    }
  };
  const handleOnHide = function () {
    fireAnalytics("close", {
      code,
      text: content || text
    });
    setIsVisible(false);
    if (triggerRef.current !== document.activeElement) {
      var _triggerRef$current2;
      triggerRef === null || triggerRef === void 0 ? void 0 : (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.focus();
    }
  };
  const handleClick = function (e) {
    e.stopPropagation();
  };
  const shouldCloseOnScroll = function (event) {
    return !event.target.classList || !event.target.closest(".tippy-content");
  };
  const TooltipContent = function () {
    const [opacity, setOpacity] = (0, _react.useState)(0);
    const scrollRef = (0, _react.useRef)(null);
    const handleScroll = function (event) {
      setOpacity(event.target.scrollTop / (event.target.offsetHeight - event.target.scrollHeight) * -1);
    };
    (0, _react.useEffect)(function () {
      if (scrollRef.current) {
        scrollRef.current.addEventListener("scroll", handleScroll, {
          passive: true
        });
      }
      return function () {
        if (scrollRef.current) {
          scrollRef.current.removeEventListener("scroll", handleScroll);
        }
      };
    }, []);
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.DisclaimerScroll, {
        ref: scrollRef,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.DisclaimerBody, {
          id: code,
          tabIndex: 0,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.CloseButton, {
            onClick: handleOnCloseClick,
            "aria-label": "Close Disclaimer",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLibrary.Close, {
              fill: "#FFF"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.DisclaimerBodyContent, {
            onClick: function (e) {
              return e.stopPropagation();
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_HtmlText.default, {
              children: text || content || "..."
            })
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.GradientDisclaimerBodyUp, {
        style: {
          opacity: opacity
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.GradientDisclaimerBodyDown, {
        style: {
          opacity: 1 - opacity
        }
      })]
    });
  };
  const fireAnalytics = (0, _analytics.default)("Disclaimer");
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(DisclaimerTheme, {
      theme: formattedTheme
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.default, {
      onCreate: onCreate,
      arrow: true,
      content: /*#__PURE__*/(0, _jsxRuntime.jsx)(TooltipContent, {}),
      onShow: handleOnShow,
      onShown: handleOnShown,
      onMount: handleOnMount,
      onHide: handleOnHide,
      appendTo: function () {
        var _document$querySelect;
        return (_document$querySelect = document.querySelector("dialog[open]")) !== null && _document$querySelect !== void 0 ? _document$querySelect : document.body;
      },
      trigger: "click",
      placement: placement,
      interactive: true,
      theme: formattedTheme === "toyota" ? "toyota" : "lexus",
      maxWidth: 230,
      flipBehavior: ["right", "left", "top", "bottom"],
      shouldCloseOnScroll: shouldCloseOnScroll,
      aria: "labelledby",
      hideOnScroll: !(formattedTheme === "toyota"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DisclaimerTrigger, {
        handleClick: handleClick,
        code: code,
        text: text,
        "aria-label": "Show Disclaimer",
        triggerRef: triggerRef,
        ...rest,
        children: children
      })
    })]
  });
};
exports.Disclaimer = Disclaimer;
var _default = exports.default = (0, _analytics.withAnalytics)((0, _styledComponentThemes.withThemes)(Disclaimer, colors))({});